"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const react_text_mask_1 = __importDefault(require("react-text-mask"));
const createNumberMask_1 = __importDefault(require("text-mask-addons/dist/createNumberMask"));
const __1 = require("..");
const hoc_1 = require("../../hoc");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
// currency input
const defaultMaskOptions = {
    prefix: '$',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 7,
    allowNegative: false,
    allowLeadingZeroes: false,
};
class Input extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            passwordVisible: false,
            isFocus: false,
        };
        this.onFocus = (e) => {
            const { onFocus } = this.props;
            if (onFocus) {
                onFocus(e);
            }
            this.setState({ isFocus: true });
        };
        this.onBlur = (e) => {
            const { onBlur } = this.props;
            if (onBlur) {
                onBlur(e);
            }
            this.setState({ isFocus: false });
        };
        this.onToggleViewPassword = () => {
            const { onToggleViewPassword } = this.props;
            const { passwordVisible } = this.state;
            if (onToggleViewPassword) {
                this.setState({ passwordVisible: !passwordVisible }, () => {
                    onToggleViewPassword(!passwordVisible);
                });
            }
        };
        this.focus = () => {
            if (this.inputRef) {
                this.inputRef.focus();
            }
        };
        this.renderDropdown = () => {
            const { dropdown, visible } = this.props;
            if (visible && dropdown) {
                return dropdown;
            }
            return null;
        };
        this.renderAccessory = () => {
            const { accessory, error, viewPasswordImage, type, accessoryPosition } = this.props;
            const { isFocus } = this.state;
            let imgSrc = null;
            let alt = '';
            if (accessory) {
                imgSrc = accessory.default;
                alt = 'accessory';
                if (isFocus) {
                    imgSrc = accessory.active;
                }
                if (!lodash_1.isEmpty(error)) {
                    imgSrc = accessory.error;
                }
            }
            if (viewPasswordImage) {
                const images = {
                    password: viewPasswordImage.close.default,
                    text: viewPasswordImage.open.default
                };
                const errorImages = {
                    password: viewPasswordImage.close.error,
                    text: viewPasswordImage.open.error
                };
                const activeImages = {
                    password: viewPasswordImage.close.active,
                    text: viewPasswordImage.open.active
                };
                imgSrc = images[type];
                if (isFocus) {
                    imgSrc = activeImages[type];
                }
                if (!lodash_1.isEmpty(error)) {
                    imgSrc = errorImages[type];
                }
            }
            if (imgSrc) {
                return (core_1.jsx("button", { type: "button", tabIndex: -1, onClick: () => {
                        if (viewPasswordImage) {
                            this.onToggleViewPassword();
                        }
                        else {
                            this.focus();
                        }
                    }, className: styles_scss_1.default.accessory, css: styles_1.default.accessory({ accessoryPosition }) },
                    core_1.jsx("img", { className: styles_scss_1.default.accessoryImage, src: imgSrc, alt: alt })));
            }
            return null;
        };
        this.renderError = () => {
            const { error } = this.props;
            if (error) {
                return error;
            }
            return null;
        };
    }
    render() {
        const _a = this.props, { className, label, name, ariaLabel, error, multiline, numberOfLines, type, maskOptions, staticLabel, helper } = _a, rest = __rest(_a, ["className", "label", "name", "ariaLabel", "error", "multiline", "numberOfLines", "type", "maskOptions", "staticLabel", "helper"]);
        const { isFocus } = this.state;
        // Delete props that shouldn't be passed to the dom
        delete rest.visible;
        delete rest.success;
        delete rest.errorImage;
        delete rest.successImage;
        delete rest.requestClose;
        delete rest.viewPasswordImage;
        delete rest.onToggleViewPassword;
        delete rest.accessoryPosition;
        let inputText;
        const props = {
            'aria-label': ariaLabel,
            id: name,
            name,
            className: carabiners_1.joinStr(styles_scss_1.default.baseInput, className),
            css: styles_1.default.input({ success: false, error: error !== '' }),
            onFocus: this.onFocus,
            onBlur: this.onBlur,
        };
        if (type === "currency") {
            const currencyMask = createNumberMask_1.default(Object.assign(Object.assign({}, defaultMaskOptions), maskOptions));
            inputText = (core_1.jsx(react_text_mask_1.default, Object.assign({ mask: currencyMask }, rest, props)));
        }
        else if (multiline) {
            inputText = core_1.jsx("textarea", Object.assign({ ref: ref => {
                    this.inputRef = ref;
                }, rows: numberOfLines }, rest, props));
        }
        else {
            inputText = core_1.jsx("input", Object.assign({ ref: ref => {
                    this.inputRef = ref;
                }, type: type }, rest, props));
        }
        return (core_1.jsx("div", { className: styles_scss_1.default.relative },
            core_1.jsx("div", { className: styles_scss_1.default.inputContainer },
                inputText,
                isFocus || staticLabel ? (core_1.jsx("small", { id: label, className: styles_scss_1.default.inputLabel, css: styles_1.default.label({ isFocus, error: error !== '' }) },
                    label,
                    rest.required ? '*' : '')) : null,
                core_1.jsx(__1.HelperText, { className: styles_scss_1.default.error }, this.renderError()),
                helper && core_1.jsx(__1.HelperText, { className: styles_scss_1.default.helper }, helper),
                this.renderAccessory(),
                this.renderDropdown())));
    }
}
Input.defaultProps = {
    ariaLabel: '',
    type: 'text',
    dropdown: null,
    visible: false,
    error: '',
    success: false,
    clean: null,
    onFocus: undefined,
    onBlur: undefined,
    onInput: undefined,
    className: null,
    accessory: null,
    label: '',
    requestClose: () => { },
    successImage: null,
    errorImage: null,
    maxLength: undefined,
    multiline: false,
    numberOfLines: 3,
    viewPasswordImage: null,
    onToggleViewPassword: undefined,
    accessoryPosition: 'right',
    maskOptions: null,
    staticLabel: false,
    required: false,
    helper: null,
};
exports.default = hoc_1.clickOutside(Input);
